import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n";

const CookieBanner = () => {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem("cookie_consent_v1");
    if (!v) setVisible(true);
  }, []);

  const set = (mode) => {
    localStorage.setItem("cookie_consent_v1", mode);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 bg-white border border-ink shadow-sm" data-testid="cookie-banner">
      <div className="p-5">
        <h3 className="font-display text-lg mb-2">Cookies</h3>
        <p className="text-sm text-ink-muted leading-relaxed mb-4">{t("cookie_message")} <Link to="/legal/privacy" className="underline">{t("learn_more")}</Link></p>
        <div className="flex gap-3">
          <button data-testid="cookie-accept-all" onClick={() => set("all")} className="btn-primary text-xs flex-1 py-3">{t("cookie_accept")}</button>
          <button data-testid="cookie-essential" onClick={() => set("essential")} className="btn-secondary text-xs flex-1 py-3">{t("cookie_essential")}</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
